import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../config";
import { useTranslation } from "react-i18next";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const ElderRegister = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("auth");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleRegister = async (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);

    try {
      await axios.post(`${config.API_BASE_URL}${config.PATIENT.REGISTER}`, {
        email,
        password
      });

      navigate("/elder-login", {
        state: { successMessage: t("elderRegister.success") }
      });
    } catch (err) {
      setError(err.response?.data?.error || t("elderRegister.failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-shell">
      <section className="page-panel">
        <div className="page-content auth-layout">
          <div className="support-card">
            <div>
              <div className="intro-badge">{t("elderRegister.badge")}</div>
              <h1 className="page-title">{t("elderRegister.title")}</h1>
              <p className="page-subtitle">{t("elderRegister.subtitle")}</p>
            </div>

            <div className="support-list">
              <div className="support-item">
                <span className="support-dot" />
                <div>
                  <div className="mini-label">{t("elderRegister.support1Title")}</div>
                  <p>{t("elderRegister.support1Text")}</p>
                </div>
              </div>
              <div className="support-item">
                <span className="support-dot" />
                <div>
                  <div className="mini-label">{t("elderRegister.support2Title")}</div>
                  <p>{t("elderRegister.support2Text")}</p>
                </div>
              </div>
              <div className="support-item">
                <span className="support-dot" />
                <div>
                  <div className="mini-label">{t("elderRegister.support3Title")}</div>
                  <p>{t("elderRegister.support3Text")}</p>
                </div>
              </div>
            </div>
          </div>

          <form className="form-card" onSubmit={handleRegister}>
            <div className="form-header">
              <h2>{t("elderRegister.formTitle")}</h2>
              <p>{t("elderRegister.formSubtitle")}</p>
            </div>

            {error && <div className="error-banner">{error}</div>}

            <div className="form-grid">
              <div className="form-field full">
                <label htmlFor="elder-register-email">{t("elderRegister.emailLabel")}</label>
                <input
                  id="elder-register-email"
                  className="text-input"
                  type="email"
                  required
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  placeholder={t("elderRegister.emailPlaceholder")}
                />
              </div>

              <div className="form-field full">
                <label htmlFor="elder-register-password">{t("elderRegister.passwordLabel")}</label>
                <div style={{ position: "relative" }}>
                  <input id="elder-register-password" className="text-input" style={{ paddingRight: "3.5rem" }} type={showPassword ? "text" : "password"} autoComplete="new-password" minLength={8} required value={password} onChange={(event) => setPassword(event.target.value)} placeholder={t("elderRegister.passwordPlaceholder")} />
                  <button type="button" style={passwordEyeButton} aria-label={showPassword ? "Hide password" : "Show password"} onClick={() => setShowPassword((shown) => !shown)}>{showPassword ? <FaEyeSlash /> : <FaEye />}</button>
                </div>
              </div>
            </div>

            <div className="button-row">
              <button className="ghost-button" type="button" onClick={() => navigate("/")}>
                {t("elderRegister.back")}
              </button>
              <button className="warm-button" type="submit" disabled={loading}>
                {loading ? t("elderRegister.submitting") : t("elderRegister.submit")}
              </button>
            </div>

            <p className="simple-note">
              {t("elderRegister.hasAccount")}{" "}
              <button
                type="button"
                className="simple-link"
                style={{ border: "none", background: "transparent", padding: 0 }}
                onClick={() => navigate("/elder-login")}
              >
                {t("elderRegister.loginLink")}
              </button>
            </p>
          </form>
        </div>
      </section>
    </div>
  );
};

const passwordEyeButton = { position: "absolute", right: "1rem", top: "50%", transform: "translateY(-50%)", border: "none", background: "transparent", color: "#5f6c76", padding: 0 };

export default ElderRegister;
